import { render } from "./CopyButton.vue?vue&type=template&id=147a8c86"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__